// ConfigInputs.js
import ConfigTab from "./ConfigTab";
import { isFeatureEnabled } from "../../../constant/featureVisibility";
import { buttonText } from "../../../utils/buttonText";

function ConfigInputs(props) {
  const { item, config, setConfig } = props;
  const visibleTabs = Object.keys(config).filter(
    (tab) => tab !== "FacialApp" || isFeatureEnabled("faceRecognition")
  );

  return (
    <div className="config-inputs">
      <nav>
        <div className="nav nav-tabs" id={`nav-tab-${item.name}`} role="tablist">
          {visibleTabs.map((tab, index) => {
            const isSelected = tab === "Common";
            return (
              <button
                key={`${item.name}-${index}`}
                className={`nav-link${tab === "Common" ? " active" : ""}`}
                id={`nav-${tab}-${item.name}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#nav-${tab}-${item.name}`}
                type="button"
                role="tab"
                aria-controls={`nav-${tab}-${item.name}`}
                aria-selected={isSelected}
              >
                {buttonText(tab)}
              </button>
            );
          })}
        </div>
      </nav>
      <div className="tab-content" id="nav-tabContent">
        {visibleTabs.map((tab) => (
          <ConfigTab key={`${item.name}-${tab}`} item={item} tab={tab} config={config} setConfig={setConfig} />
        ))}
      </div>
    </div>
  );
}

export default ConfigInputs;
